export const COUNTRIES = ["Togo", "Sénégal", "Côte d'Ivoire", "Cameroun", "Bénin", "Mali", "Burkina Faso", "Ghana", "France"];
export const PROPERTY_TYPES = ["Terrain", "Maison", "Appartement", "Villa", "Bureau", "Local commercial", "Immeuble", "Hôtel", "Autre"];
export const TRANSACTIONS = [
  { value: "vente", label: "Acheter" },
  { value: "location", label: "Louer" },
  { value: "investir", label: "Investir" },
];
export const REQUEST_STATUS = ["Nouvelle", "En traitement", "En attente", "Terminée"];
export const CRM_STAGES = [
  { value: "nouveau", label: "Nouveau prospect" },
  { value: "contacte", label: "Contacté" },
  { value: "qualifie", label: "Qualifié" },
  { value: "visite", label: "Visite / RDV" },
  { value: "proposition", label: "Proposition" },
  { value: "negociation", label: "Négociation" },
  { value: "conclusion", label: "Conclusion" },
  { value: "client", label: "Client" },
];
export const BLOG_CATEGORIES = ["Immobilier", "Investissement", "Conseils aux propriétaires", "Diaspora", "Construction", "Gestion immobilière", "Conciergerie", "Actualités"];
